let alertTimeout

function showAlert(message, type = 'success', duration = 3000) {
  const alert = document.getElementById('alert-notification')
  const alertText = document.getElementById('alert-text')

  if (alertTimeout) {
    clearTimeout(alertTimeout)
  }

  alertText.textContent = message
  alert.classList.remove('success', 'error', 'warning')
  alert.classList.add(type)
  alert.classList.add('show')

  if (duration > 0) {
    alertTimeout = setTimeout(() => {
      closeAlert()
    }, duration)
  }
}

function closeAlert() {
  const alert = document.getElementById('alert-notification')
  alert.classList.remove('show')

  if (alertTimeout) {
    clearTimeout(alertTimeout)
    alertTimeout = null
  }
}

// Função global para mostrar alertas (usada pelo carrinho)
window.mostrarAlerta = function (message, type = 'success') {
  showAlert(message, type)
}

document.addEventListener('DOMContentLoaded', () => {
  // Atualizar contador do carrinho quando a página carregar
  setTimeout(() => {
    if (window.atualizarContadorCarrinho) {
      window.atualizarContadorCarrinho()
    }
  }, 500)

  // Busca do nav
  const buscaInput = document.querySelector('nav .busca input')
  const resultadosBusca = document.querySelector('nav .busca .resultados-busca')

  if (buscaInput && resultadosBusca) {
    let timeoutBusca
    buscaInput.addEventListener('input', function () {
      const termo = this.value.trim()
      clearTimeout(timeoutBusca)
      if (termo.length < 1) {
        resultadosBusca.style.display = 'none'
        resultadosBusca.innerHTML = ''
        return
      }
      // Pequeno delay para evitar requisições em excesso
      timeoutBusca = setTimeout(() => {
        resultadosBusca.innerHTML = '<div class="resultado-item buscando"><span class="loading"></span></div>'
        resultadosBusca.style.display = 'flex'
        fetch(`/search/suggest.json?q=${encodeURIComponent(termo)}&resources[type]=product&resources[limit]=5`)
          .then((res) => res.json())
          .then((data) => {
            const produtos = data.resources && data.resources.results && data.resources.results.products ? data.resources.results.products : []
            if (produtos.length === 0) {
              resultadosBusca.innerHTML = '<div class="sem-resultado">Nenhum produto encontrado.</div>'
              return
            }
            resultadosBusca.innerHTML = produtos
              .map(
                (produto) => `
              <a href="${produto.url}" class="resultado-item">
                <div class="foto" style="background-image: url('${produto.image || '/assets/banner-capa.png'}')"></div>
                <span>${produto.title}</span>
              </a>
            `
              )
              .join('')
          })
          .catch(() => {
            resultadosBusca.innerHTML = '<div class="sem-resultado">Erro ao buscar produtos.</div>'
          })
      }, 200)
    })
    // Esconde o balão ao clicar fora
    document.addEventListener('click', function (e) {
      if (!buscaInput.contains(e.target) && !resultadosBusca.contains(e.target)) {
        resultadosBusca.style.display = 'none'
      }
    })
    // Mostra o balão ao focar se já tem texto
    buscaInput.addEventListener('focus', function () {
      if (this.value.trim().length > 0 && resultadosBusca.innerHTML) {
        resultadosBusca.style.display = 'flex'
      }
    })
  }
})


// Perf 17/10/2026: capas dos cards de produto (.previa[data-bg]) só baixam quando chegam perto da tela.
// Também cobre cards recolocados na página por JS (ex.: limpar a busca da coleção) via MutationObserver.
;(function () {
  function mostrar(el) {
    var url = el.getAttribute('data-bg')
    if (!url) return
    el.style.backgroundImage = "url('" + url + "')"
    el.removeAttribute('data-bg')
  }
  if (!('IntersectionObserver' in window)) {
    var todos = function () { document.querySelectorAll('.previa[data-bg]').forEach(mostrar) }
    document.addEventListener('DOMContentLoaded', todos)
    return
  }
  var io = new IntersectionObserver(function (entradas) {
    entradas.forEach(function (e) {
      if (e.isIntersecting) { mostrar(e.target); io.unobserve(e.target) }
    })
  }, { rootMargin: '600px 0px' })
  function observar(raiz) {
    if (!raiz || !raiz.querySelectorAll) return
    if (raiz.matches && raiz.matches('.previa[data-bg]')) io.observe(raiz)
    raiz.querySelectorAll('.previa[data-bg]').forEach(function (el) { io.observe(el) })
  }
  observar(document)
  document.addEventListener('DOMContentLoaded', function () {
    observar(document)
    new MutationObserver(function (ms) {
      ms.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) observar(n) }) })
    }).observe(document.body, { childList: true, subtree: true })
  })
})()
